module.exports = __webpack_public_path__ + "img/logo-white.6f4e094b.png";